export default __webpack_public_path__ + "static/bg-97e789610d441d27b254038a91f184d8.png";